// extracted by mini-css-extract-plugin
export var Component = "acc-module--Component--d4e48";
export var Component__Img = "acc-module--Component__Img--bcdc8";
export var Section = "acc-module--Section--c6bee";